import type { oz } from '@weft/utils';
import { UsageProductVariantSchema } from '../usage-product-variant-schema';
import { PerUnitPricingSchema } from './per-unit-pricing-schema';

export const PerUnitProductVariantSchema = UsageProductVariantSchema
  .extend({ pricing: PerUnitPricingSchema })
  .openapi('PerUnitProductVariant');

export type PerUnitProductVariant = oz.infer<typeof PerUnitProductVariantSchema>;